import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { Spinner } from '@/components/ui/spinner'
import { clientPathAfterPaymentReturn } from '@/lib/native'
import { RoutePath } from '@/RoutePath'

export default function NativeReturnPage() {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    navigate(clientPathAfterPaymentReturn(location.search) || RoutePath.ClientPkg, { replace: true })
  }, [location.search, navigate])

  return (
    <div className='flex min-h-[50vh] items-center justify-center'>
      <Spinner className='size-10' />
    </div>
  )
}
